export default "__VITE_ASSET__Bb39GWyW__"